import './SobDemanda.css';
import { IconeFaiscas, IconeJanela, IconePlanilha, IconeSeta, IconeWhatsApp } from '../Icones/Icones';
import { CTA_SOB_DEMANDA } from '../../config';

const SERVICOS = [
    {
        Icone: IconeJanela,
        titulo: 'Landing pages e sites institucionais',
        texto: 'Presença online rápida para o seu negócio, sem enrolação.',
    },
    {
        Icone: IconePlanilha,
        titulo: 'Automação de planilhas',
        texto: 'Sua rotina em Excel ou Google Sheets virando algo automático, com baixo custo e sem precisar de um sistema inteiro.',
    },
    {
        Icone: IconeFaiscas,
        titulo: 'Ferramentas com IA',
        texto: 'Assistentes e automações com inteligência artificial aplicados à rotina da sua empresa.',
    },
];

function SobDemanda() {
    return (
        <section id="sob-demanda" className="secao sob-demanda">
            <div className="container">
                <div className="secao-cabecalho revelar">
                    <span className="rotulo">Sob demanda</span>
                    <h2 className="titulo-secao">Também fazemos projetos sob demanda</h2>
                    <p className="subtitulo-secao">
                        Nem todo problema precisa de um sistema completo. Às vezes, o que resolve é algo mais
                        simples e rápido.
                    </p>
                </div>

                <ul className="servicos">
                    {SERVICOS.map(({ Icone, titulo, texto }, i) => (
                        <li key={titulo} className="servico revelar" style={{ '--atraso': `${i * 0.1}s` }}>
                            <span className="servico-icone"><Icone tamanho={24} /></span>
                            <div>
                                <h3>{titulo}</h3>
                                <p>{texto}</p>
                            </div>
                        </li>
                    ))}
                </ul>

                <div className="sob-demanda-acao revelar">
                    <a href={CTA_SOB_DEMANDA.url} className="btn btn-primario" target="_blank" rel="noopener noreferrer">
                        <IconeWhatsApp tamanho={18} />
                        {CTA_SOB_DEMANDA.texto}
                        <IconeSeta tamanho={18} />
                    </a>
                </div>
            </div>
        </section>
    );
}

export default SobDemanda;
